// extracted by mini-css-extract-plugin
export default {"borderedFooter":"FeaturedCommentsContainer-borderedFooter-d795f905ee83071c05b77b131401ba00"};